import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import { OrbitFieldSelect } from '../components/orbitFieldSelect';
import { Checkbox } from '../../../components/general/fields/checkbox';
import { OrbitSectionHeader } from '../components/orbitSectionHeader';
import { useOrbitSpecialCondition } from './hook';
import { OrbitSpecialConditionProps } from '../sectionProps';
import { getOptionLabel } from '../utils/formatOrbitSelect';

export const OrbitSpecialCondition = (props: OrbitSpecialConditionProps) => {
    const { readOnly } = props;
    const {
        formik,
        specialConditionOptions,
        loadingSpecialConditions,
        specialConditionsError,
    } = useOrbitSpecialCondition(props);
    const disabled = Boolean(readOnly);

    const specialConditionLabel = readOnly
        ? formik.values.specialCondition
        : getOptionLabel(
            specialConditionOptions,
            formik.values.specialCondition
        );

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <OrbitSectionHeader title="Condición Especial" />
            </Grid>

            <Grid item xs={12} md={4}>
                {readOnly ? (
                    <FieldText
                        label="¿Presenta alguna condición especial?"
                        name="hasSpecialCondition"
                        size="small"
                        disabled
                        value={formik.values.hasSpecialCondition ? 'Sí' : 'No'}
                    />
                ) : (
                    <Checkbox
                        beforeLabel="Condición especial"
                        label="¿Presenta alguna condición especial?"
                        checked={Boolean(formik.values.hasSpecialCondition)}
                        onChange={() => {
                            formik.setFieldValue(
                                'hasSpecialCondition',
                                !formik.values.hasSpecialCondition
                            );
                        }}
                        onBlur={formik.handleBlur}
                    />
                )}
            </Grid>

            {formik.values.hasSpecialCondition && (
                <>
                    <Grid item xs={12} md={4}>
                        {readOnly ? (
                            <FieldText
                                label="Condición especial"
                                name="specialCondition"
                                size="small"
                                disabled
                                value={specialConditionLabel}
                            />
                        ) : (
                            <OrbitFieldSelect
                                data={specialConditionOptions}
                                label="Condición especial"
                                name="specialCondition"
                                size="small"
                                required
                                disabled={
                                    loadingSpecialConditions ||
                                    Boolean(specialConditionsError) ||
                                    specialConditionOptions.length === 0
                                }
                                emptyOptionLabel={
                                    loadingSpecialConditions
                                        ? 'Cargando condiciones...'
                                        : specialConditionsError
                                            ? 'Catálogo no disponible'
                                            : 'Seleccionar condición...'
                                }
                                onBlur={formik.handleBlur}
                                touched={
                                    formik.touched.specialCondition ||
                                    Boolean(specialConditionsError)
                                }
                                errors={
                                    formik.errors.specialCondition ||
                                    specialConditionsError
                                }
                                value={formik.values.specialCondition}
                                onChange={formik.handleChange}
                            />
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <FieldText
                            label="Observaciones especiales del ciudadano"
                            name="observations"
                            size="small"
                            required
                            rows={3}
                            disabled={disabled}
                            inputProps={{ readOnly: disabled }}
                            onBlur={formik.handleBlur}
                            touched={formik.touched.observations}
                            errors={formik.errors.observations}
                            value={formik.values.observations}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
